import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import Team from '@/views/Team.vue'
import Demands from '@/views/Demands.vue'
import Planning from '@/views/Planning.vue'
import Allocation from '@/views/Allocation.vue'



Vue.use(VueRouter)

  const routes = [
  
  //  O 8 redireciona todas as todas não encontrada para a rota que você desejar.
  {
    path: '*',
    redirect: '/',
  },
  
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    icon: 'mdi-view-dashboard',
    menu: true
  },
  {
    path: '/equipe',
    name: 'Equipe',
    component: Team,
    icon: 'mdi-account',
    menu: true
  },
  {
    path: '/demandas',
    name: 'Demandas',
    component: Demands,
    icon: 'mdi-briefcase-account',
    menu: true
  },
  {
    path: '/planeja',
    name: 'Planejamento',
    component: Planning,
    icon: 'mdi-calendar-arrow-right',
    menu: true
  },
  {
    path: '/alocacao',
    name: 'Alocações',
    component: Allocation,
    icon: 'mdi-map-marker-check ',
    menu: true
  }



  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
